import { fetch } from '@/common/request';
import { ProcessListVo } from './application';

export interface AuthUserVo {
  id?: number;
  tenantName?: string;
  tenantMcid?: string;
  status?: string;
  processList?: ProcessListVo[];
}

export interface AuthSaveVo {
  processIds?: number[];
  tenantMcid?: string;
  tenantName?: string;
}

export interface UpdateStatusVo {
  id: number;
  status: boolean;
}

export interface TenantListVo {
  id?: number;
  name?: string;
  tenantMcid?: string;
}
export interface TenantAuthListVo {
  id?: number;
  name?: string;
  description?: string;
  definition?: string;
  welcome?: string;
  createTime?: string;
  updateTime?: string;
}

// 授权租户列表
export function getAuthList(): Promise<AuthUserVo[]> {
  return fetch(
    '/api/auth/list',
    {
      method: 'POST',
    },
    true
  );
}

// 保存授权关系
export function saveAuth(params: AuthSaveVo): Promise<any> {
  return fetch(
    '/api/auth/save',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

// 启用、禁用
export function updateStatus(params: UpdateStatusVo): Promise<any> {
  return fetch(
    '/api/auth/enable',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

// 删除授权租户
export function deleteAuth(id: number): Promise<any> {
  return fetch(
    '/api/auth/delete',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

// 租户列表
export function getTenantList(): Promise<TenantListVo[]> {
  return fetch(
    '/api/auth/tenant/list',
    {
      method: 'POST',
    },
    true
  );
}

// 根据租户ID获取已授权的智能体列表
export function getAuthorizedAgents(tenantMcid: string): Promise<TenantListVo[]> {
  return fetch(
    '/api/auth/tenant/agents',
    {
      method: 'POST',
      body: JSON.stringify({ tenantMcid }),
    },
    true
  );
}

// 租户授权应用列表
export function getApplicationList(): Promise<TenantAuthListVo> {
  return fetch(
    '/api/auth/tenant/authList',
    {
      method: 'POST',
    },
    true
  );
}
